import { isEqual } from 'lodash'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { ISupplierLastSelectedState } from '~/types/supplier/models'

const supplierLastSelectedStateListData =
  undefined as unknown as ISupplierLastSelectedState[]

export const getSupplierLastSelectedStateListData = getListDataFunctionFactory<
  ISupplierLastSelectedState[]
>({
  listData: supplierLastSelectedStateListData,
  storageKey: 'supplierlastselectedstates',
  getStartingListData: getStartingSupplierLastSelectedStateListData,
})

export async function getSupplierLastSelectedStateData(
  id: TEntityId
): Promise<ISupplierLastSelectedState> {
  const list: ISupplierLastSelectedState[] =
    await getSupplierLastSelectedStateListData()
  if (!list) {
    throw new Error(`getSupplierLastSelectedStateList returned undefined/null`)
  }
  const supplierLastSelectedState = list.find((slsd) => slsd.id === id)
  if (!supplierLastSelectedState) {
    throw new Error(`Can't find supplierLastSelectedState '${id}'`)
  }
  return supplierLastSelectedState
}

export async function getSupplierLastSelectedStateDataBySupplierId(
  id: TEntityId
): Promise<ISupplierLastSelectedState | undefined> {
  const list: ISupplierLastSelectedState[] =
    await getSupplierLastSelectedStateListData()
  if (!list) {
    throw new Error(`getSupplierLastSelectedStateList returned undefined/null`)
  }
  const supplierLastSelectedState = list.find((slsd) =>
    isEqual(slsd.supplierId, id)
  )
  return supplierLastSelectedState
}

export async function getStartingSupplierLastSelectedStateListData(): Promise<
  ISupplierLastSelectedState[]
> {
  return []
}
